<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import CourseTrainerCard from "@components/course/CourseTrainerCard.svelte";
	import { courseTrainers } from "../../courseTrainers.js";

	const { label, title }: { label: string; title: string } = $props();
</script>

<section class="py-14 sm:py-17 md:py-20">
	<div class="text-center mb-8 md:mb-12">
		<div class="uppercase text-fcrorange font-bold tracking-[.1em]">
			<Formatted text={label} />
		</div>
		<Heading level={2} text={title} class="heading-2 text-fcrdarkgray mt-4" />
	</div>
	<div class="grid gap-10 lg:grid-cols-2 lg:gap-12 max-w-240 mx-auto">
		{#each courseTrainers as trainer (trainer.name)}
			<CourseTrainerCard {trainer} />
		{/each}
	</div>
</section>
